import { patchUserProfile } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { SexEnum } from '@uplift/types';
import { useUpdateSettingsHandlers } from '@uplift/ui-v2';
import * as Yup from 'yup';
import { SettingsData } from '../../../hooks/use-settings-data.hook';

export type SexFormType = {
  sex: SexEnum;
};

export const useSexForm = (userId: string, data: SettingsData) => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettingsHandlers(userId, l10n.providerSettings.sex);

  const sexFormik = () => {
    const initialValues: SexFormType = {
      sex: data?.profile?.sex ?? SexEnum.female
    };

    const validationSchema = Yup.object({
      sex: Yup.string().required(l10n.validations.required)
    });

    const onSubmit = async (values: SexFormType) => {
      try {
        await patchUserProfile(userId, {
          sex: values.sex
        });

        await onFormSubmitSuccess(true);
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { sexFormik };
};
